var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitingCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23999 5.26584V11.6658C2.23999 12.3728 2.81307 12.9458 3.51999 12.9458H12.48C13.1869 12.9458 13.76 12.3728 13.76 11.6658V5.26584C13.76 4.55892 13.1869 3.98584 12.48 3.98584H3.51999C2.81307 3.98584 2.23999 4.55892 2.23999 5.26584Z",
    stroke: "#5F488A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91992 9.18579H11.8399",
    stroke: "#5F488A",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91992 11.1057H11.8399",
    stroke: "#5F488A",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76173 8.36195L7.18302 10.6263C7.26255 11.0538 7.80571 11.1389 7.99901 10.7541L10.0457 6.68003C10.1248 6.52242 10.1083 6.34822 10.0291 6.21559M6.76173 8.36195L5.23155 6.79544C4.94892 6.50609 5.14261 6 5.53599 6H9.65912C9.82045 6 9.95342 6.0888 10.0291 6.21559M6.76173 8.36195L10.0291 6.21559M10.0291 6.21559L10.0577 6.19683",
    stroke: "#5F488A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitingCard);
export default __webpack_public_path__ + "static/media/visitingCard.88cb3bab8f7fc02be2e6ee0a30a7b650.svg";
export { ForwardRef as ReactComponent };